var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WEB-MobileFirst",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_Dashboard",
    transform: "translate(-869.000000, -499.000000)",
    fill: "#353535",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(481.000000, 466.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(388.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2029053,8.48459473 C10.4881311,7.76984619 9.6373645,7.24071899 8.70912964,6.9204126 C9.70329712,6.23568237 10.3564453,5.08973145 10.3564453,3.79394531 C10.3564453,1.70196899 8.65447632,0 6.5625,0 C4.47052368,0 2.76855469,1.70196899 2.76855469,3.79394531 C2.76855469,5.08973145 3.42170288,6.23568237 4.415896,6.9204126 C3.48766113,7.24071899 2.63689453,7.76984619 1.92212036,8.48459473 C0.682628174,9.72411255 0,11.3720947 0,13.125 L1.02539062,13.125 C1.02539062,10.0718225 3.50932251,7.58789062 6.5625,7.58789062 C9.61567749,7.58789062 12.0996094,10.0718225 12.0996094,13.125 L13.125,13.125 C13.125,11.3720947 12.4423718,9.72411255 11.2029053,8.48459473 Z M6.5625,6.5625 C5.03592407,6.5625 3.79394531,5.32054687 3.79394531,3.79394531 C3.79394531,2.26734375 5.03592407,1.02539062 6.5625,1.02539062 C8.08907593,1.02539062 9.33105469,2.26734375 9.33105469,3.79394531 C9.33105469,5.32054687 8.08907593,6.5625 6.5625,6.5625 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.09ce9066d13a2267952c50597df8b61f.svg";
export { ForwardRef as ReactComponent };